import 'angular:locale/data:de';
import 'zone.js';(globalThis.$localize ??= {}).locale = "de";
